import React from "react";
import Editable from "react-bootstrap-editable";

const ParameterContent = ({ parameterValue, setParameterValue }) => {
  return (
    <div className="center w-full md:w-1/2 lg:w-2/3 mx-0.5 mt-1 rounded-lg">
      <div className="w-full rounded-md aiso_glass_in_bg">
        <div className="md:flex items-center font-bold py-3 px-4 inoutput_header">
          <div className="whitespace-pre text-base mr-2">파라미터 입력</div>
        </div>
        <div className="md:h-52 lg:h-40 py-3">
          {parameterValue ? (
            <div className="w-full px-4 flex flex-col">
              {/* 파라미터 타입 설명 */}
              <div className="w-full block md:flex">
                <p className="flex justify-start text-333 text-base font-bold mb-0 mr-3 mt-3">type</p>
                <div className="flex flex-wrap mt-2">
                  <p className="bg-white px-2.5 py-1 mb-0 rounded-full mr-1.5 mt-2">str</p>
                  <p className="bg-white px-2.5 py-1 mb-0 rounded-full mr-1.5 mt-2">bool</p>
                  <p className="bg-white px-2.5 py-1 mb-0 rounded-full mr-1.5 mt-2">int</p>
                  <p className="bg-white px-2.5 py-1 mb-0 rounded-full mr-1.5 mt-2">float</p>
                </div>
              </div>
              <div className="w-full mt-8">
                <div className="w-full">
                  {Object.keys(parameterValue["values"]).map((m, i) => (
                    <div key={m} className="w-full block lg:flex mt-2">
                      <p className="flex justify-start text-333 text-base font-bold mb-0 mr-3 mt-3">{`${m}  (${parameterValue["types"][m]})`}</p>
                      {/* TODO: Editable 빈값 체크 찾아보기 */}
                      <div className="flex flex-wrap mt-2">
                        <Editable
                          initialValue={parameterValue["values"][Object.keys(parameterValue["values"])[i]]}
                          //   isValueClickable
                          editText={<div className="btn glass_in_btn btn-sm ml-3">{`변경`}</div>}
                          mode="inline"
                          className="w-full _eitable"
                          onSubmit={(e) => {
                            /* parameter 변경 값 저장하기 */
                            let tempData = parameterValue;
                            tempData["values"][m] = e;
                            setParameterValue(tempData);
                          }}
                        />
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          ) : (
            ""
          )}
        </div>
      </div>
    </div>
  );
};
export default ParameterContent;
